'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditLog = require('./audit-log.routes');

var _auditLog2 = _interopRequireDefault(_auditLog);

var _auditLogs = require('./audit-logs.controller');

var _auditLogs2 = _interopRequireDefault(_auditLogs);

var _auditLogDetailsDialog = require('./audit-log-details-dialog.controller');

var _auditLogDetailsDialog2 = _interopRequireDefault(_auditLogDetailsDialog);

var _auditLogHeader = require('./audit-log-header.directive');

var _auditLogHeader2 = _interopRequireDefault(_auditLogHeader);

var _auditLogRow = require('./audit-log-row.directive');

var _auditLogRow2 = _interopRequireDefault(_auditLogRow);

var _auditLogTable = require('./audit-log-table.directive');

var _auditLogTable2 = _interopRequireDefault(_auditLogTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.auditLog', []).config(_auditLog2.default).controller('AuditLogsController', _auditLogs2.default).controller('AuditLogDetailsDialogController', _auditLogDetailsDialog2.default).directive('tbAuditLogHeader', _auditLogHeader2.default).directive('tbAuditLogRow', _auditLogRow2.default).directive('tbAuditLogTable', _auditLogTable2.default).name;


// WEBPACK FOOTER //
// ./src/app/audit/index.js